import SearchShipments from './SearchShipments';

export default SearchShipments;
